// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { Badge } from './ui/badge';
import { Clock, AlertCircle, Archive } from 'lucide-react';

/**
 * Visual indicator for the 5-year retention window (S-27 §59).
 * Renders only when within 30 days of expiration or after.
 */
export default function RetentionBadge({ retentionUntil }) {
  if (!retentionUntil) return null;

  const target = new Date(retentionUntil);
  const now = new Date();
  const daysLeft = Math.floor((target - now) / (1000 * 60 * 60 * 24));

  if (daysLeft > 30) return null;

  if (daysLeft < 0) {
    return (
      <Badge className="bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300" data-testid="retention-expired">
        <Archive className="w-3 h-3 mr-1" />
        Retenção expirada
      </Badge>
    );
  }

  const tone = daysLeft <= 7
    ? 'bg-red-50 text-red-700 dark:bg-red-950 dark:text-red-300'
    : 'bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-300';
  const Icon = daysLeft <= 7 ? AlertCircle : Clock;

  return (
    <Badge className={tone} data-testid="retention-warning">
      <Icon className="w-3 h-3 mr-1" />
      Expira em {daysLeft} dia{daysLeft === 1 ? '' : 's'}
    </Badge>
  );
}
